import { SubSink } from 'subsink';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@monorepo/ui/auth';

@Component({
  selector: 'signgaze-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss'],
})
export class SocialLoginComponent implements OnDestroy {
  readonly subs = new SubSink();

  isSubmitted = false;
  loginBy: string;
  google = 'GOOGLE';
  twitter = 'TWITTER';
  facebook = 'FACEBOOK';

  constructor(private auth: AuthService, private router: Router) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private navigateToDashboard(): void {
    this.subs.sink = this.auth.user.subscribe((user) => {
      if (user) {
        this.router.navigateByUrl('/dashboard');
      }
    });
  }

  public loginInWithTwitter(): void {
    this.loginBy = this.twitter;
    this.isSubmitted = true;
    this.auth
      .twitterLogin()
      .then((status) => {
        if (status) {
          this.isSubmitted = false;
          this.navigateToDashboard();
        }
      })
      .catch(() => {
        this.isSubmitted = false;
      });
  }

  public loginInWithFaceBook(): void {
    this.loginBy = this.facebook;
    this.isSubmitted = true;
    this.auth
      .facebookLogin()
      .then((status): void => {
        if (status) {
          this.isSubmitted = false;
          this.navigateToDashboard();
        }
      })
      .catch(() => {
        this.isSubmitted = false;
      });
  }

  public loginInWithGoogle(): void {
    this.loginBy = this.google;
    this.isSubmitted = true;
    this.auth
      .googleLogin()
      .then((status) => {
        if (status) {
          this.isSubmitted = false;
          this.navigateToDashboard();
        }
      })
      .catch(() => {
        this.isSubmitted = false;
      });
  }
}
